import * as ActionTypes from '../../constants/actionTypes';
import {getFilteredFeatures, sortFeaturesArray, updateUnlinkedDataFromToolSettings} from "./featuresFunctions";
import {FEATURE_ENABLED_PROPERTIES} from "./FeaturesSetupFeature/featureInterface";
import {percentage} from "../../misc";
import {loadFeaturesSetupFeatures} from "./featuresAsyncActions";
import {MARK_UP_APPLY_TO_TYPES} from "./FeaturesSetupMarkPopup/markUpItemInterface";
import {getSameApplyTo} from "./FeaturesSetupMarkPopup/markUpFunctions";

export const setFeatureCreatorFeatureGroup = (groupName, catId) => ({
  type: ActionTypes.FEATURES_SETUP_SET_FEATURE_GROUP,
  payload: {groupName, catId}
});

export const clearFeaturesSetup = () => ({
  type: ActionTypes.FEATURES_SETUP_CLEAR,
});

export const featuresSetupSetSearchTerm = (searchTerm) => {
  return (dispatch, getState) => {
    const {featuresListAllFeatures} = getState().featuresSetupState;
    let newFeaturesList = [...featuresListAllFeatures];
    if (searchTerm) {
      const lowerCasedSearchText = searchTerm.trim().toLowerCase();
      newFeaturesList = newFeaturesList.filter(dbFeature => {
        if (!dbFeature || !dbFeature.name || (typeof dbFeature.name !== "string")) {
          return false
        }
        return dbFeature.name.trim().toLowerCase().includes(lowerCasedSearchText);
      })
    }
    dispatch({type: ActionTypes.FEATURES_SETUP_SET_SEARCH_TERM,
      payload: {searchTerm, featuresList: newFeaturesList}
    })
  }
};

export const setFeaturesSetupTogglePopupOpened = (featuresSetupTogglePopupOpened, featuresSetupTogglePopupFeature = null) => ({
  type: ActionTypes.FEATURES_SETUP_TOGGLE_POPUP_OPENED,
  payload: {featuresSetupTogglePopupOpened, featuresSetupTogglePopupFeature}
});

export const setFeaturesSetupDeletePopupOpened = (featuresSetupDeletePopupOpened) => ({
  type: ActionTypes.FEATURES_SETUP_DELETE_POPUP_OPENED,
  payload: {featuresSetupDeletePopupOpened}
});

export const toggleFeaturesSetupSharedFeatureName = (sharedFeatureNameToggleValue) => ({
  type: ActionTypes.FEATURES_SETUP_SHARED_FEATURE_NAME_TOGGLE,
  payload: {sharedFeatureNameToggleValue}
});

export const featuresSetupSetContentType = (featuresContentType) => ({
  type: ActionTypes.FEATURES_SETUP_SET_CONTENT_TYPE,
  payload: {featuresContentType}
});

export const featuresSetupSetPendingFeatures = (pendingFeatures) => ({
  type: ActionTypes.FEATURES_SETUP_SET_PENDING_FEATURES,
  payload: {pendingFeatures}
});

export const featuresSetupSetEditPopupFeatureId = (editPopupFeatureId) => ({
  type: ActionTypes.FEATURES_SETUP_SET_EDIT_POPUP_FEATURE_ID,
  payload: {editPopupFeatureId}
});

export const featuresSetupShowShippingSetupPopup = (showShippingSetupPopup) => ({
  type: ActionTypes.FEATURES_SETUP_SHOW_SHIPPING_SETUP_POPUP,
  payload: {showShippingSetupPopup}
});

export const featuresSetupShowMarkUpDownPopup = (showMarkUpDownPopup) => ({
  type: ActionTypes.FEATURES_SETUP_SHOW_MARK_UP_DOWN_POPUP,
  payload: {showMarkUpDownPopup}
});

const getNewFeatureValue = (currentValue, newValue, updatePrice = false, catId = "", prop = "") => {
  if (catId && prop === "unlinkedDataJson" && !newValue) {
    return JSON.stringify({[catId]: newValue})
  } else if (updatePrice) {
    if (newValue.includes && newValue.includes("%")) {
      const percentFromNum = percentage(currentValue, +newValue.split("%")[0]);
      return currentValue + percentFromNum
    } else {
      return currentValue + newValue
    }
  }
  return newValue
}

const getUpdatedFeaturePriceFromMarkItem = (markUpListItem, originalValue) => {
  const {type, priceType, value} = markUpListItem;
  const changeValue = (priceType === "percentage")
    ? percentage(+originalValue, +value)
    : +value;
  let newValue = type === "mark_up" ? +originalValue + changeValue : +originalValue - changeValue;
  return newValue < 0 ? 0 : +(newValue.toFixed(2));
}

const setDbFeatureUpdatedProp = (dbFeature, property, newValue) => {
  if (dbFeature.unlinkedData) {
    dbFeature.unlinkedData[property] = newValue;
  } else {
    dbFeature[property] = newValue;
  }
  return dbFeature
}

const restoreFeatureOriginalValues = (newDbFeature, originalValues) => {
  const {price, cost, shippingCost} = originalValues;
  newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "price", price);
  newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "cost", cost);
  newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "shippingCost", shippingCost);
  return newDbFeature
}

export const setFeaturePriceFromMarkItem = (markUpItem, newDbFeature, forUnlinkedData = false) => {
  // console.log("markUpItem", markUpItem, newDbFeature);
  const {price, cost, shippingCost} = markUpItem.originalValues;
  switch (markUpItem.applyTo) {
    case MARK_UP_APPLY_TO_TYPES.retailPrice: {
      const newPrice = getUpdatedFeaturePriceFromMarkItem(markUpItem, price);
      newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "price", newPrice);
      break;
    }
    case MARK_UP_APPLY_TO_TYPES.cost: {
      const newCost = getUpdatedFeaturePriceFromMarkItem(markUpItem, cost);
      newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "cost", newCost);
      break;
    }
    case MARK_UP_APPLY_TO_TYPES.retailPriceAndCost: {
      const newPrice = getUpdatedFeaturePriceFromMarkItem(markUpItem, price);
      const newCost = getUpdatedFeaturePriceFromMarkItem(markUpItem, cost);
      newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "price", newPrice);
      newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "cost", newCost);
      break;
    }
    case MARK_UP_APPLY_TO_TYPES.shippingCost: {
      const newCost = getUpdatedFeaturePriceFromMarkItem(markUpItem, shippingCost);
      newDbFeature = setDbFeatureUpdatedProp(newDbFeature, "shippingCost", newCost);
      break;
    }
    default:
      break;
  }
  // console.log("newDbFeature", newDbFeature);
  return newDbFeature
}

const getUpdatedOriginalValues = (dbFeature, newMarkUpLogic = [], forUnlinkedData = false) => {
  let {cost, price, shippingCost} = forUnlinkedData ? dbFeature.unlinkedData : dbFeature; // set it from feature as new first
  let originalValues = {cost, price, shippingCost}; // set it from feature as new first

  ["price", "cost", "shippingCost"].forEach(property => {
    const existingOldLogic = newMarkUpLogic.find(markItem => {
      switch (property) {
        case "price":
          return markItem.applyTo === MARK_UP_APPLY_TO_TYPES.retailPrice || markItem.applyTo === MARK_UP_APPLY_TO_TYPES.retailPriceAndCost
        case "cost":
          return markItem.applyTo === MARK_UP_APPLY_TO_TYPES.cost || markItem.applyTo === MARK_UP_APPLY_TO_TYPES.retailPriceAndCost
        case "shippingCost":
          return markItem.applyTo === MARK_UP_APPLY_TO_TYPES.shippingCost
        default:
          return false
      }
    });
    if (existingOldLogic) {
      originalValues[property] = existingOldLogic.originalValues[property];
    }
  })
  return originalValues
}

/**
 * returns the same list for several features-setup components
 * @param dbFeature {featureInterface}
 * @param markUpListItem {[markUpItemInterface]|markUpItemInterface} // here we can receive array[] or single markUpItem
 * @param forUnlinkedData {boolean}
 * @param catId {string|number}
 * @returns dbFeature {featureInterface}
 */
const getNewFeatureUpdatedMarkUpLogic = (dbFeature, markUpListItem, forUnlinkedData = false, catId = "") => { // todo

  // 1) first we update feature markUpLogic property

  let newDbFeature = Object.assign({}, dbFeature);
  let newMarkUpLogic = Array.isArray(markUpListItem) ? [...markUpListItem] : []; // just replace, we already did all changes before

  let originalValues = getUpdatedOriginalValues(dbFeature, newMarkUpLogic, forUnlinkedData);

  if (!Array.isArray(markUpListItem) && typeof markUpListItem === "object") { // typeof [] is also object! so check 2 times
    // we need to check old existing values in same object
    let newMarkUpItem = Object.assign({}, markUpListItem);
    newMarkUpLogic = newDbFeature.markUpLogic && Array.isArray(JSON.parse(newDbFeature.markUpLogic))
      ? JSON.parse(newDbFeature.markUpLogic)
      : [];
    if (newMarkUpLogic.length) {
      originalValues = getUpdatedOriginalValues(dbFeature, newMarkUpLogic, forUnlinkedData); // we always keep old values, to be able to restore them

      const existingMarkUpItem = newMarkUpLogic.find(markUpItem => markUpItem.id === markUpListItem.id);
      if (existingMarkUpItem) {
        newMarkUpLogic = newMarkUpLogic.map(markUpItem => (markUpItem.id === newMarkUpItem.id) ? newMarkUpItem : markUpItem);
      } else {
        newMarkUpLogic = newMarkUpLogic.filter(markUpItem => { // delete old same logic items
          return !getSameApplyTo(markUpListItem.applyTo, markUpItem.applyTo);
        });
        newMarkUpLogic.push(markUpListItem);
      }
    } else {
      newMarkUpLogic.push(newMarkUpItem);
    }
  } else if (Array.isArray(markUpListItem)) { // ok, we have a new array, but we need to check if something is removed
    const oldMarkUpLogic = newDbFeature.markUpLogic && Array.isArray(JSON.parse(newDbFeature.markUpLogic))
      ? JSON.parse(newDbFeature.markUpLogic)
      : [];
    if (oldMarkUpLogic.length) { //check if it has anything that should be deleted
      originalValues = getUpdatedOriginalValues(dbFeature, oldMarkUpLogic, forUnlinkedData); // we always keep old values, to be able to restore them
      // const shouldBeDeleted = oldMarkUpLogic.filter(markItem => !markUpListItem.some(mItem => mItem.id === markItem.id))
      // if (shouldBeDeleted.length) {
      //   shouldBeDeleted.forEach(markUpItem => { // restore values!
      //     newDbFeature = setFeaturePriceFromMarkItem(markUpItem, newDbFeature, true);
      //   })
      // }
    }
  }
  newMarkUpLogic.forEach(markUpItem => {
    markUpItem.originalValues = Object.assign({}, originalValues); // 1) set for all items same updated old values
    if (forUnlinkedData && catId) {
      markUpItem.forUnlinkedCatId = +catId; // is used to detect same features in other categories
    }
  });
  newDbFeature = restoreFeatureOriginalValues(newDbFeature, originalValues, forUnlinkedData);  // 2) clear old before apply new
  newDbFeature.markUpLogic = JSON.stringify(newMarkUpLogic); // 3) save new prop

  //2) now let's update feature properties that markUpLogic is affecting on
  newMarkUpLogic.forEach(markUpItem => {
    newDbFeature = setFeaturePriceFromMarkItem(markUpItem, newDbFeature, forUnlinkedData);
  });
  return newDbFeature
}

const setter = (feature, prop, newValue, pendingFeatures, catId, updatePrice) => {
  if (prop === "selected") {
    feature[prop] = newValue;
    return Object.assign({}, feature);
  }
  if (feature.unlinkedData && (prop !== "unlinkedData" && prop !== "unlinkedDataJson")) {
    switch(prop) {
      case 'hasKv':
        feature.unlinkedData.hideFromKV = !newValue;
        break;
      case 'hasQt':
        feature.unlinkedData.hideFromKVQT = !newValue;
        break;
      case 'hasBv':
        feature.unlinkedData.hideFromBV = !newValue;
        break;
      case 'hasBvQt':
        feature.unlinkedData.hideFromBVQT = !newValue;
        break;
      case "price":
        feature.unlinkedData.price = getNewFeatureValue(feature.unlinkedData.price, newValue, updatePrice, catId, prop);
        break;
      case "cost":
        feature.unlinkedData.cost = getNewFeatureValue(feature.unlinkedData.cost, newValue, updatePrice, catId, prop);
        break;
      case "name":
        feature.unlinkedData.displayName = newValue;
        break;
      case "toolSettings": {
        if (!Array.isArray(feature.toolSettings) || !feature.toolSettings.length) {
          break;
        }
        feature.unlinkedData.toolSettings = newValue;
        feature.unlinkedData = updateUnlinkedDataFromToolSettings(feature.unlinkedData, feature.toolSettings);
        break;
      }
      case "markUpLogic":
        feature = getNewFeatureUpdatedMarkUpLogic(feature, newValue, true, catId); // todo
        pendingFeatures[feature.featureDefinitionId] = {
          ...pendingFeatures[feature.featureDefinitionId],
          markUpLogic: feature.markUpLogic,
        }
        break;
      default:
        feature.unlinkedData[prop] = newValue;
        break;
    }
    feature.unlinkedData = {...feature.unlinkedData};
    pendingFeatures[feature.featureDefinitionId] = {
      ...pendingFeatures[feature.featureDefinitionId],
      unlinkedData: {...feature.unlinkedData},
      unlinkedDataJson: JSON.stringify({[catId]: {...feature.unlinkedData}})
    }
  } else if (prop === "markUpLogic") {
    const oldFeature = Object.assign({}, feature);
    feature = getNewFeatureUpdatedMarkUpLogic(feature, newValue, false);
    // we are not updating price in the pending features, to prevent recaching!
    // now we update on feature load and in the visualizer separately.
    // ["price", "cost", "shippingCost", "markUpLogic"].forEach(property => {
    //   if (oldFeature[property] !== feature[property]) {
    //     pendingFeatures[feature.featureDefinitionId] = {
    //       ...pendingFeatures[feature.featureDefinitionId],
    //       [property]: feature[property]
    //     };
    //   }
    // })
    if (oldFeature["markUpLogic"] !== feature["markUpLogic"]) {
      pendingFeatures[feature.featureDefinitionId] = {
        ...pendingFeatures[feature.featureDefinitionId],
        ["markUpLogic"]: feature["markUpLogic"]
      };
    }
  } else if (feature[prop] !== newValue || updatePrice) {
    const realNewValue = getNewFeatureValue(feature[prop], newValue, updatePrice, catId, prop);
    // console.log("realNewValue", realNewValue);
    feature[prop] = realNewValue;
    pendingFeatures[feature.featureDefinitionId] = {
      ...pendingFeatures[feature.featureDefinitionId],
      [prop]: realNewValue
    };
    if (prop === "toolSettings") {
      feature.enabled = feature.toolSettings.some(toolSettingsObject => toolSettingsObject.enableQuotingTool || toolSettingsObject.enableVisualizer);
      pendingFeatures[feature.featureDefinitionId].enabled = feature.enabled;
      pendingFeatures[feature.featureDefinitionId].toolSettings_save = JSON.stringify(feature.toolSettings);
    } else if (FEATURE_ENABLED_PROPERTIES.some(property => property === prop)) {
      const featureIsEnabled = FEATURE_ENABLED_PROPERTIES.every(property => feature[property]);
      if (featureIsEnabled !== feature.enabled) {
        feature.enabled = featureIsEnabled;
        pendingFeatures[feature.featureDefinitionId] = {
          ...pendingFeatures[feature.featureDefinitionId],
          enabled: featureIsEnabled
        };
      }
    }
  }
  return Object.assign({}, feature);
};

/**
 * @param dbFeature {featureInterface}
 * @param propName {string|array<string>}
 * @param propValue {any}
 * @param pendingFeatures {object}
 * @param catId {string}
 * @param updatePending {boolean}
 * @param updatePrice {boolean}
 */
const updateFeature = (dbFeature,
                       propName,
                       propValue,
                       pendingFeatures = {},
                       catId = "",
                       updatePending = true,
                       updatePrice = false) => {
  if (Array.isArray(propName) && Array.isArray(propValue)) { // multiple properties update, for example, propName = ["enabled", "locked"], propValue = [false, true]
    // console.log("dbFeature before", dbFeature);
    propName.forEach((property, propertyIndex) => {
      const objectToUpdate = updatePending ? pendingFeatures : {};
      dbFeature = setter(dbFeature, property, propValue[propertyIndex], objectToUpdate, catId, updatePrice);
    });
    // console.log("dbFeature after", dbFeature);
    return dbFeature
  } else {
    const objectToUpdate = updatePending ? pendingFeatures : {};
    return setter(dbFeature, propName, propValue, objectToUpdate, catId, updatePrice);
  }
}

/**
 * @param feature {featureInterface}
 * @param propName {string|array<string>}
 * @param propValue {any}
 * @param updatePending {boolean}
 */
export const featuresSetupUpdateFeature = (feature, propName, propValue, updatePending = true) => {
  return (dispatch, getState) => {

    let {featuresList, pendingFeatures, catId, editPopupFeatureId} = getState().featuresSetupState;

    const newFeaturesList = featuresList.map(dbFeature => {
      if (dbFeature.featureDefinitionId === feature.featureDefinitionId) {
        return updateFeature(dbFeature, propName, propValue, pendingFeatures, catId, updatePending)
      }
      return dbFeature
    })

    dispatch({
      type: ActionTypes.FEATURES_SETUP_UPDATE_FEATURE,
      payload: {
        featuresList: newFeaturesList,
        pendingFeatures,
      }
    });

    if (editPopupFeatureId) { // on edit popup close
      dispatch(featuresSetupSetEditPopupFeatureId(null));
    }
  }
}

/**
 * @param propName {string}
 * @param propValue {any}
 * @param applyToFeatures {[featureInterface]}
 * @param updatePrice {boolean}
 // * @param selectedOnly {boolean}
 */
export const featuresSetupUpdateFeatures = (propName, propValue, applyToFeatures, updatePrice = false) => {
  return (dispatch, getState) => {
    const store = getState();
    let {featuresList, pendingFeatures, catId} = getState().featuresSetupState;
    if (!applyToFeatures) {
      applyToFeatures = getFilteredFeatures(store, propName !== "selected", true);
    }
    if (!applyToFeatures.length) {
      applyToFeatures = getFilteredFeatures(store, false, true)
    }

    const newFeaturesList = featuresList.map(dbFeature => {
      if (applyToFeatures.some(applyToFeature => applyToFeature.featureDefinitionId === dbFeature.featureDefinitionId)
        && (dbFeature[propName] !== propValue)) {
        let newValue = (propName === "toolSettings")
          ? [...propValue.map(obj => Object.assign({}, obj))]
          : propValue; // prevent set the same array on all features
        return updateFeature(dbFeature, propName, newValue, pendingFeatures, catId, true, updatePrice)
      }
      return dbFeature
    });

    dispatch({
      type: ActionTypes.FEATURES_SETUP_UPDATE_FEATURES,
      payload: {
        featuresList: [...newFeaturesList],
        pendingFeatures,
      }
    })
  }
}


/**
 * @param featureData {object}
 * @param state {object}
 */
export const updateFeatureAfterEditPopup = (featureData, state) => {
  const {featuresList, editPopupFeatureId} = state.featuresSetupState;
  const feature = featuresList.find(feature => feature.featureDefinitionId === editPopupFeatureId);
  if (!feature) {
    if (featureData.group) { // it is a new feature - go ahead request again all features to receive a new one
      return loadFeaturesSetupFeatures(featureData.group, featureData.catId);
    }
    return null
  }
  let newPropNames = [];
  let newPropValues = [];
  const matchingPropertiesObject = {
    "name": "name",
    "sku": "sku",
    "description": "description",
    "hasBvQt": "forBathroomQuotingTool",
    "hasBv": "forBathroomVisualizer",
    "hasKv": "forKitchenVisualizer",
    "hasQt": "forQuotingTool",
    "uofM": "unit",
    "imageUrl": "thumbnailImageUrl",
    "toolSettings": "toolSettings",
  }
  Object.keys(matchingPropertiesObject).forEach(property => {
    if (feature[property] !== featureData[matchingPropertiesObject[property]]) {
      newPropNames.push(property);
      newPropValues.push(featureData[matchingPropertiesObject[property]]);
    }
  });
  if (newPropNames.length) {
    return featuresSetupUpdateFeature(feature, newPropNames,  newPropValues, false)
  }
  return null
}

/**
 * @param featuresChanges {object}
 * @param featuresList {[featureInterface]}
 * @param dispatch {function}
 * @param auth {object}
 */
export const updateFeaturesAfterSave = (featuresChanges, featuresList, dispatch, auth) => {
  let needToUpdateFeatures = false;
  featuresList = featuresList.map(feature => {
    if (featuresChanges.values[feature.featureDefinitionId]
      && featuresChanges.values[feature.featureDefinitionId].hasOwnProperty("enabled")
      && (featuresChanges.values[feature.featureDefinitionId] !== feature.isEnabled)) {
      feature.isEnabled = featuresChanges.values[feature.featureDefinitionId].enabled;
      if (!needToUpdateFeatures) {
        needToUpdateFeatures = true
      }
    }
    return feature
  })
  if (needToUpdateFeatures) {
    dispatch({
      type: ActionTypes.FEATURES_SETUP_UPDATE_FEATURES,
      payload: {
        featuresList: sortFeaturesArray(featuresList, auth),
      }
    })
  }
}
